import { gerarCodigoVerificacao } from "./generate-code.js";
import { observeElementorMessage } from "./check-sucess-message.js";
import { verifyCode } from "./verify-code.js";
import { loadModal } from "./load-modal.js";
import { getWithExpiry } from "./local-storage.js";
import { badgeDataLayer } from "./theme-datalayers.js";

const currentPage = window.location.pathname === "/" ? "home" : "other";
const isChecked = getWithExpiry("userChecked");

if (!isChecked && currentPage !== "home") {
  loadModal(currentPage);
  console.log("The modal is open because the user is not checked.");
} else {
  console.log("The user is checked.");
}

let codigodeverificacao = gerarCodigoVerificacao();
verifyCode(codigodeverificacao);
observeElementorMessage();

//push datalayers
badgeDataLayer();